<template>
    <div class="order-list-item">
        <div class="list-item-header">
            <div class="order-status">{{ item.status | orderState }}</div>
            <div class="order-number">訂單編號：{{ item.order_number }}</div>
        </div>
        <div class="list-item-body" @click="toDetail">
            <div class="order-date">訂單日期：{{ item.ordered_at | dateFormat }}</div>
            <div class="product-name">{{ item.product.name }}</div>
            <div class="summary">{{ item.product.summary }}</div>
        </div>
        <div class="list-item-footer">
            <div class="price">月付 <strong>NT$ {{ item.period_amount }}</strong> * {{ item.period_count }}期</div>
        </div>
    </div>
</template>

<script>
    import moment from 'moment';
    import {status} from '@/constants/order';

    export default {
        name: "OrderListItem",
        props: {
          item: {
              type: Object
          }
        },
        filters: {
            dateFormat: function (value) {
                if (value === undefined) {
                    return "";
                }
                return moment(value).format("YYYY-MM-DD HH:mm:ss");
            },
            orderState(value) {
                return status[value];
            }
        },
        methods: {
            toDetail() {
                this.$router.push({name: 'OrderDetail', params: {order_id: this.item.order_id}})
            }
        }
    }
</script>

<style scoped lang="scss">
    .order-list-item {
        color: #707070;
        display: flex;
        flex-direction: column;
        margin-bottom: 2.5rem;

        .list-item-header {
            display: flex;
            flex-direction: row;
            align-items: center;
            margin-bottom: 8px;

            .order-status {
                padding: 4px 16px;
                border-radius: 5px;
                color: #DC0000;
                border: 1px solid #DC0000;
            }

            .order-number {
                margin-left: 8px;
            }
        }

        .list-item-body {
            cursor: pointer;
            border: 1px solid #39C5BC;
            padding: 32px;

            .product-name {
                color: black;
                font-size: 28px;
            }
        }

        .list-item-footer {
            display: flex;
            flex-direction: row;
            justify-content: flex-end;

            .price strong {
                margin-left: 4px;
            }
        }
    }
</style>